import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { isSignupSocialAllowed } from '../../shared/utils/host.util';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Trial / demo mode bypasses token check
  if (auth.isTrial()) {
    return true;
  }

  if (auth.isLoggedIn() && auth.isTokenValid()) {
    return true;
  }

  // Token present but expired — clear stale data before redirecting
  if (auth.isLoggedIn() && !auth.isTokenValid()) {
    auth.logout();
  }

  return router.createUrlTree(['/login']);
};

export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn() && !auth.isTrial()) {
    return true;
  }
  return router.createUrlTree(['/dashboard']);
};

// Blocks the signup routes on any host where signup/social login isn't enabled
// (see environment.redirectDomainUrl) — the OAuth redirect URIs aren't registered
// there, so the flow can't complete. Redirects such visits back to /login. The
// native Capacitor app is allowed except on iOS, where registration is hidden
// entirely (see isSignupSocialAllowed).
export const signupDomainGuard: CanActivateFn = () => {
  const router = inject(Router);

  if (isSignupSocialAllowed()) {
    return true;
  }
  return router.createUrlTree(['/login']);
};
